<template>
    <div role="form">
        <div
            class="qr"
            v-if="state.currentView == 'WECHAT_CODE_VIEW' && state.processing != true"
        >
            <div class="payment__body__success-img">
                <h5
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{$t("wechat.init.instruction")}}
                </h5>
                <figure class="qr-code">
                    <img
                        :src="checkoutData.view.context.qrcode"
                        alt="qr code"
                        class="container__col-sm-12 container__col-md-12 qr-code__img"
                        loading="lazy" 
                        decoding="async"
                    />
                </figure>
                <PrimaryButton :content="$t('ui.redirect.btn')" @click="Next" />
            </div>
        </div>
        <div
            v-else-if="
                state.currentView == 'WECHAT_INIT_VIEW' && state.processing != true
            "
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("wechat.redirect.instruction")}}
            </h5>
            <PrimaryButton :content="$t('wechat.redirect.btn')" @click="Next" />
        </div>
    </div>
</template>

<script>
import { getValueFromPath } from "@/support/helpers";
import PrimaryButton from "@/components/form/base-button";
import { injectStore, mapState } from "redux-vuex";
import { ref, onBeforeUnmount } from "vue";

export default {
    name: "QrPayment",
    components: { PrimaryButton },
    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const transactionSuccessful = ref(false);

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        onBeforeUnmount(() => {
            subscription();
        });

        return {
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
                qrCode: (state) =>
                    getValueFromPath(state, "view.context.qrcode") || null,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
            }),
            checkoutData,
            transactionSuccessful,
            Next,
        };
    },
};
</script>

<style lang="scss" scoped>
.qr {
  display: flex;
  flex-direction: column;
}
.qr-code {
  width: 70%;
  margin: 0 auto;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 10px;
  &__img {
    width: 100%;
    object-fit: cover;
    object-position: 0% 100%;
    image-rendering: pixelated;
  }
}
</style>